import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { SmtpConfigurationService } from 'src/app/service/smtp-configuration/smtp-configuration.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DesignService } from 'src/app/service/design/design.service';
import { Title } from '@angular/platform-browser';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { finalize, map } from 'rxjs/operators';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

declare var $: any;

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.scss'],
})
export class DesignComponent implements OnInit {
  @ViewChild('site_log_inp') siteLogoInp: ElementRef;
  @ViewChild('site_favicon_inp') siteFaviconInp: ElementRef;

  designData;
  designForm: FormGroup;
  egan_hub_site_logo;
  egan_hub_favicon;
  userPermissions;

  // @Input() design_setting: any;

  message;
  egan_hub_primary_color1;
  fb;
  downloadURL: Observable<string>;
  constructor(
    private formBuilder: FormBuilder,
    private smtpConfiguration: SmtpConfigurationService,
    private designService: DesignService,
    private titleService: Title,
    private toastService: ToastService,
    private storage: AngularFireStorage,
    // Still needed in order for getAndParseUserPermissions to work.
    private localStorageService: LocalstorageService,
  ) { }

  ngOnInit(): void {
    this.getDesignDetails();
    this.initializeForm();
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
  }

  initializeForm(data = null) {
    if (data != null) {
      if (data.egan_hub_site_logo != '') {
        try {
          let siteLogo = this.storage.ref('uploads/site_logo/' + data.egan_hub_site_logo);
          if (siteLogo) {
            siteLogo.getDownloadURL().subscribe(url => {
              if (url) {
                this.egan_hub_site_logo = url;
              }
            });
          }
        } catch (error) { }
      }
      if (data.egan_hub_favicon != '') {
        try {
          let siteFavicon = this.storage.ref('uploads/site_logo/' + data.egan_hub_favicon);
          if (siteFavicon) {
            siteFavicon.getDownloadURL().subscribe(url => {
              if (url) {
                this.egan_hub_favicon = url;
              }
            });
          }
        } catch (error) { }
      }
      // this.site_logo = "http://localhost/uploads/site_logo/" + data.site_logo;
      // this.egan_hub_favicon = "http://localhost/uploads/site_logo/" + data.egan_hub_favicon;
      if (
        data.egan_hub_primary_color != '' &&
        data.egan_hub_primary_color != null &&
        data.egan_hub_primary_color != undefined
      ) {
        this.egan_hub_primary_color1 = data.egan_hub_primary_color;
      } else {
        this.egan_hub_primary_color1 = '#d91e41';
      }
      this.designForm = this.formBuilder.group({
        egan_hub_site_logo: [data.egan_hub_site_logo],
        egan_hub_favicon: [data.egan_hub_favicon],
        egan_hub_site_title: [data.egan_hub_site_title, Validators.required],
        egan_hub_primary_color: [data.egan_hub_primary_color, Validators.required],
      });
    } else {
      this.designForm = this.formBuilder.group({
        egan_hub_site_logo: [''],
        egan_hub_favicon: [''],
        egan_hub_site_title: ['', Validators.required],
        egan_hub_primary_color: ['', Validators.required],
      });
    }
  }

  getDesignDetails() {
    this.smtpConfiguration.getSiteConfiguration(true, true).subscribe(
      res => this.onSuccess(res),
      error => this.onError(),
    );
  }

  onSuccess(result) {
    if (typeof result.data) {
      if (result.data) {
        let newArray = {};
        result.data.forEach(element => {
          newArray[element.config_item] = element.config_value;
        });
        this.initializeForm(newArray);
        this.designData = newArray;
      }
    }
  }

  onError() { }

  onFileSelect(event, type) {
    if (event.target.files.length > 0) {
      let flag = 1;
      const file = event.target.files[0];

      if (event.target.files.length === 0) return;

      // var mimeType = event.target.files[0].type;
      // if (mimeType.match(/image\/*/) == null) {
      //   this.message = "Only images are supported.";
      //   return;
      // }
      var fileSize = Math.round(event.target.files[0].size / 1024);
      if (fileSize > 1024) {
        flag = 0;
        this.message = 'File is too large';
      }

      if (type == 'egan_hub_site_logo') {
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);

        img.onload = function () {
          if (img.height > 40) {
            flag = 0;
            alert('Please upload logo in allowed dimensions, height must be less than equal to 40px');
          }
        };
      }

      setTimeout(() => {
        if (flag == 1) {
          this.designForm.get(type).setValue(file);
          var reader = new FileReader();

          reader.readAsDataURL(event.target.files[0]);
          reader.onload = _event => {
            if (type == 'egan_hub_site_logo') {
              this.egan_hub_site_logo = reader.result;
            } else {
              this.egan_hub_favicon = reader.result;
            }
          };
        } else {
          if (type == 'egan_hub_site_logo') this.siteLogoInp.nativeElement.value = '';
          else {
            this.siteFaviconInp.nativeElement.value = '';
          }
        }
      }, 500);
    }
  }

  onSubmit(form) {
    let formData = new FormData();
    // if (this.designForm.get('site_logo').value.name) {
    //   formData.append('site_logo', this.designForm.get('site_logo').value, this.designForm.get('site_logo').value.name);
    // }
    // if (this.designForm.get('egan_hub_favicon').value.name) {
    //   formData.append('egan_hub_favicon', this.designForm.get('egan_hub_favicon').value, this.designForm.get('egan_hub_favicon').value.name);
    // }
    formData.append('egan_hub_site_title', form.value.egan_hub_site_title);

    formData.append('egan_hub_primary_color', form.value.egan_hub_primary_color);

    if (this.designForm.get('egan_hub_site_logo').value) {
      if (this.designForm.get('egan_hub_site_logo').value.name) {
        var n = `${Date.now()}_${this.designForm.get('egan_hub_site_logo').value.name}`;
        const filePath = `uploads/site_logo/${n}`;
        const fileRef = this.storage.ref(filePath);
        const task = this.storage.upload(`uploads/site_logo/${n}`, this.designForm.get('egan_hub_site_logo').value);
        formData.append('egan_hub_site_logo', n);
        form.value.egan_hub_site_logo = n;
        task
          .snapshotChanges()
          .pipe(
            finalize(() => {
              this.downloadURL = fileRef.getDownloadURL();
              this.downloadURL.subscribe(url => {
                if (url) {
                  this.egan_hub_site_logo = url;
                }
              });
            }),
          )
          .subscribe();
      }
    }
    if (this.designForm.get('egan_hub_favicon').value) {
      if (this.designForm.get('egan_hub_favicon').value.name) {
        var n = `${Date.now()}_${this.designForm.get('egan_hub_favicon').value.name}`;
        const filePath1 = `uploads/site_logo/${n}`;
        const fileRef1 = this.storage.ref(filePath1);
        const task1 = this.storage.upload(`uploads/site_logo/${n}`, this.designForm.get('egan_hub_favicon').value);
        formData.append('egan_hub_favicon', n);
        form.value.egan_hub_favicon = n;
        task1
          .snapshotChanges()
          .pipe(
            finalize(() => {
              this.downloadURL = fileRef1.getDownloadURL();
              this.downloadURL.subscribe(url => {
                if (url) {
                  this.egan_hub_favicon = url;
                }
              });
            }),
          )
          .subscribe();
      }
    }

    this.smtpConfiguration.addUpdateSiteConfiguration(form.value).subscribe(
      res => this.onSaveSuccess(res),
      error => this.onSaveError(error),
    );
  }

  changeVal(val) {
    this.egan_hub_primary_color1 = val;
    this.designForm.get('egan_hub_primary_color').setValue(val);
  }

  onSaveSuccess(result) {
    if (result.data) {
      this.siteLogoInp.nativeElement.value = '';
      this.siteFaviconInp.nativeElement.value = '';
      document.documentElement.style.setProperty(
        '--primary-color',
        this.designForm.get('egan_hub_primary_color').value,
      );
      this.titleService.setTitle(this.designForm.get('egan_hub_site_title').value);
      this.getDesignDetails();
      document.getElementById('appSiteFavicon').setAttribute('href', this.egan_hub_favicon);
      document.getElementById('appSiteLogo').setAttribute('src', this.egan_hub_site_logo);
      this.toastService.showToast('Design configuration updated successfully', 'success');
    }
  }

  onSaveError(error) { }
}
